import SEO from "../components/SEO";
import ContactSection from "../components/ContactSection";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="relative pt-32 md:pt-40 pb-24 bg-[#FBF8EF]">
      <SEO
        title="Contact"
        description="Écrire à Pulaar — disponibilité, commande, collaboration. Atelier Paris. info@pulaar.co · @pulaar.co"
        path="/contact"
      />
      <ContactSection />
    </main>
  );
}
